var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('px-ofertas-filters',{attrs:{"type":_vm.type,"value":_vm.value,"query":_vm.query,"filters":_vm.filters,"is-search":_vm.isSearch,"is-favoritos":_vm.isFavoritos},on:{"change":_vm.change,"remove":_vm.remove}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }